import { graphql } from '../../generated';

export const PRODUCT_TAX_RATE = graphql(`
  query ProductTaxRate($productId: ID!, $productVariantId: ID!, $countryCode: String!) {
    product(id: $productId) {
      id
      productVariant(id: $productVariantId) {
        id
        taxRate(countryCode: $countryCode)
      }
    }
  }
`);

export const SET_CART_LIMIT = graphql(`
  mutation SetCartLimit($cartLimit: Int!, $productId: ID!) {
    setCartLimit(input: { cartLimit: $cartLimit, productId: $productId }) {
      product {
        id
        cartLimit
      }
    }
  }
`);

export const SET_PRODUCT_SHIPPING_OPTIONS = graphql(`
  mutation SetProductShippingOptions(
    $productId: ID!
    $shippingRequirements: [ShippingRequirement!]
    $prohibitedShippingTags: [String!]
    $freeShippingMode: FreeShippingMode
  ) {
    setProductShippingOptions(
      input: {
        productId: $productId
        shippingRequirements: $shippingRequirements
        prohibitedShippingTags: $prohibitedShippingTags
        freeShippingMode: $freeShippingMode
      }
    ) {
      product {
        id
        shippingRequirements
        prohibitedShippingTags
        freeShippingMode
      }
    }
  }
`);

export const SET_IMMEDIATE_PAYMENT = graphql(`
  mutation SetImmediatePaymentAtStockQuota($immediatePaymentAtStockQuota: Float!, $productId: ID!) {
    setImmediatePaymentAtStockQuota(
      input: { immediatePaymentAtStockQuota: $immediatePaymentAtStockQuota, productId: $productId }
    ) {
      product {
        id
        immediatePaymentAtStockQuota
      }
    }
  }
`);

export const COMBINED_PRODUCTS = graphql(`
  query GetCombinedProducts($productId: ID!) {
    product(id: $productId) {
      id
      combinedProducts {
        id
        name
        artist
        sku
        __typename
        ... on MerchProduct {
          color
          productType
        }
      }
    }
  }
`);
